import React from "react";
import FeatureDetailLayout from "../components/FeatureDetailLayout";

export default function KingdomInsights() {
  return (
    <FeatureDetailLayout
      seoTitle="Kingdom Insights"
      seoPath="/kingdom-insights"
      noindex
      eyebrow="Kingdom Insights"
      title="Predictive insights that"
      highlight="understand your body"
      description="Kingdom Insights transforms your health data into clear, personalized insights. It doesn't just show you numbers — it explains what they mean and tells you what to do next."
      eagle
      benefits={[
        { icon: "LineChart", title: "Predictive analytics", desc: "Anticipate plateaus, peaks and recovery needs before they happen." },
        { icon: "Lightbulb", title: "Explained clearly", desc: "Every insight comes with a plain-language explanation of why it matters." },
        { icon: "Compass", title: "Actionable next steps", desc: "Insights always end with a recommendation — never just a chart." },
        { icon: "Layers", title: "Cross-signal analysis", desc: "Combines training, nutrition, sleep and body data for a complete picture." },
        { icon: "Bell", title: "Proactive alerts", desc: "Get notified when something needs attention, from fatigue to trends." },
        { icon: "Crown", title: "Kingdom Score linked", desc: "See exactly which factors are driving your overall Kingdom Score." },
      ]}
      howItWorks={[
        { title: "Aggregate signals", desc: "Jollof Fit Kingdom unifies data from every connected source into one place." },
        { title: "Detect patterns", desc: "Pattern analysis surfaces meaningful trends you'd otherwise miss." },
        { title: "Guide your next move", desc: "You receive clear, personalized recommendations you can act on today." },
      ]}
    />
  );
}
